export const webviewRoutesArray = [
  {
    path: 'cashbox/:type/:payment_id',
    name: 'webview-cashbox',
    meta: { auth: true },
    component: () => import('pages/CashboxPage.vue'),
  },
  {
    path: 'sport',
    name: 'webview-sport',
    component: () => import('pages/SportsWebview.vue'),
  },
  {
    path: 'poker',
    name: 'webview-poker',
    component: () => import('pages/Poker.vue'),
  },
  {
    path: 'competitions/:type?',
    name: 'webview-competitions',
    component: () => import('pages/CompetitionsList.vue'),
  },
  {
    path: 'competition/:id',
    name: 'webview-competition',
    component: () => import('components/competitions/CompetitionNew.vue'),
  },
  {
    path: 'rules/:slug',
    name: 'WebviewRuleNew',
    component: () => import('src/pages/RuleNew.vue'),
  },
]

const webviewLoyaltyLayoutRoutesArray = [
  {
    name: 'WebviewLoyaltyAchievements',
    path: 'achievements',
    meta: { auth: true },
    component: () => import('pages/loyalty/LoyaltyAchievements.vue'),
  },
  {
    name: 'WebviewLoyaltyShop',
    path: 'shop',
    meta: { auth: true },
    component: () => import('pages/loyalty/LoyaltyShop.vue'),
  },
  {
    name: 'WebviewLoyaltyMap',
    path: 'map',
    meta: { auth: true },
    component: () => import('src/pages/loyalty/Map.vue'),
  },
]

export const webviewLoyaltyRoutesArray = [
  {
    path: 'loyalty',
    children: [
      {
        path: '',
        name: 'WebviewLoyaltyHome',
        component: () => import('pages/loyalty/landing/LoyaltyLanding.vue'),
      },
      {
        path: '',
        component: () => import('layouts/LoyaltyLayout.vue'),
        children: webviewLoyaltyLayoutRoutesArray,
      },
    ],
  },
]

export const webviewLoyaltyRouteNameByBase = {
  LoyaltyHome: 'WebviewLoyaltyHome',
  LoyaltyMap: 'WebviewLoyaltyMap',
  LoyaltyShop: 'WebviewLoyaltyShop',
  LoyaltyAchievements: 'WebviewLoyaltyAchievements',
  ruleNew: 'WebviewRuleNew',
}

const WEBVIEW_PATH_SEGMENT = 'webview'

export function isWebviewPath(path) {
  if (typeof path !== 'string') {
    return false
  }

  return path.split('/').includes(WEBVIEW_PATH_SEGMENT)
}

function collectRouteNames(routes) {
  return routes.flatMap((route) => [
    ...(route.name ? [route.name] : []),
    ...(route.children ? collectRouteNames(route.children) : []),
  ])
}

export const webviewRouteNames = collectRouteNames([...webviewRoutesArray, ...webviewLoyaltyRoutesArray])

export const webviewLoyaltyLayoutRouteNames = collectRouteNames(webviewLoyaltyLayoutRoutesArray)
